var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListHeader',{staticClass:"text-sm cursor-default"},[_c('div',{staticClass:"flex -mx-3 text-sm"},[_c('div',{staticClass:"w-64 px-3"}),_c('div',{staticClass:"flex-1 px-3 capitalize"},[_vm._v(" "+_vm._s(_vm.$te('name') ? _vm.$t('name') : 'name')+" / "+_vm._s(_vm.$te('description') ? _vm.$t('description') : 'description')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }